<template>
  <div class="gm-split gm-html-design">
    <div class="gm-stack">
      <div class="gm-toolbar">
        <gs-button variant="outline" @click="mobile = !mobile">{{ mobile ? 'Desktop preview' : 'Mobile preview' }}</gs-button>
        <gs-button variant="outline" :disabled="!history.length" @click="undo()">Undo edit</gs-button>
      </div>
      <iframe class="gm-preview-frame" :class="{ 'gm-preview-mobile': mobile }" :srcdoc="preview(value)" title="Editable template preview" sandbox="" />
    </div>
    <aside class="gm-panel gm-stack">
      <h2>Edit your design</h2>
      <p class="gm-muted">Update text, images and links without changing the template’s layout. Use HTML for advanced styling.</p>
      <label class="gm-field">Content
        <select v-model.number="selected" @change="resetField()">
          <option v-for="field in fields" :key="field.id" :value="field.id">{{ field.id + 1 }}. {{ field.label }} — {{ field.value.trim().slice(0, 55) }}</option>
        </select>
      </label>
      <template v-if="current">
        <label class="gm-field">{{ current.label }}
          <textarea v-if="current.kind === 'text'" v-model="draft" rows="7" />
          <input v-else v-model="draft" :type="['src', 'href'].includes(current.kind) ? 'url' : 'text'" />
        </label>
        <p v-if="error" class="gm-error" role="alert">{{ error }}</p>
        <gs-button variant="outline" :disabled="draft === current.value" @click="apply()">Apply edit</gs-button>
      </template>
      <p v-else class="gm-muted">This design has no editable text or images. Use the HTML tab to customize it.</p>
    </aside>
  </div>
</template>
<script>
import { htmlDesignFields, updateHtmlDesign } from './html-design';
import { previewDocument } from './contracts';
export default {
  props: { value: { type: String, default: '' } },
  data: () => ({ selected: 0, draft: '', error: '', mobile: false, history: [] }),
  computed: {
    fields() { return htmlDesignFields(this.value); },
    current() { return this.fields[this.selected]; }
  },
  watch: { value() { this.resetField(); } },
  created() { this.resetField(); },
  methods: {
    preview: previewDocument,
    resetField() { this.draft = this.current ? this.current.value : ''; this.error = ''; },
    apply() {
      try {
        const html = updateHtmlDesign(this.value, this.current, this.draft);
        this.history.push(this.value);
        if (this.history.length > 20) this.history.shift();
        this.$emit('input', html);
        this.error = '';
      } catch (error) { this.error = error.message; }
    },
    undo() { this.$emit('input', this.history.pop()); }
  }
};
</script>
<style scoped>
@media (max-width: 900px) {
  .gm-html-design > aside { grid-row: 1; }
  .gm-html-design .gm-preview-frame { height: 440px; min-height: 0; }
}
</style>
